import { IComponentOptions } from 'angular';
import { CreditGapsClassOfTableCtrl } from './credit-gaps-class-of-table.controller';

export const CreditGapsClassOfTableComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentFilter: '<',
  },
  controller: CreditGapsClassOfTableCtrl,
  template: require('./credit-gaps-class-of-table.html'),
};
